export const getSelectedDeparturePostalOperators = state =>
  state.postalOperatorMailboxSelector.departure.nodes
    .map(node => ({
      ...node,
      children: node.children.filter(child =>
        state.postalOperatorMailboxSelector.departure.checkedMailboxes
          .includes(child.value)),
    }))
    .filter(node => node.children && node.children.length);

export const getDeparturePostalOperators =
  state => state.postalOperatorMailboxSelector.departure.nodes;
export const getDepartureCheckedMailboxes =
  state => state.postalOperatorMailboxSelector.departure.checkedMailboxes;
export const getExpandedDeparturePostalOperators =
  state => state.postalOperatorMailboxSelector.departure.expandedPostalOperators;
export const getExpandedDeparturePostalOperatorsMailboxAdmin =
  state => state.postalOperatorMailboxSelector.departure.expandedPostalOperatorsMailboxAdmin;
export const getDepartureMailboxSelections =
  state => state.postalOperatorMailboxSelector.departure.selections;
export const getDeparturePostalOperatorMailboxIsLoading =
  state => state.postalOperatorMailboxSelector.departure.isLoading;

export const getSelectedArrivalPostalOperators = state =>
  state.postalOperatorMailboxSelector.arrival.nodes
    .map(node => ({
      ...node,
      children: node.children.filter(child =>
        state.postalOperatorMailboxSelector.arrival.checkedMailboxes
          .includes(child.value)),
    }))
    .filter(node => node.children && node.children.length);

export const getArrivalPostalOperators = state => state.postalOperatorMailboxSelector.arrival.nodes;
export const getArrivalCheckedMailboxes =
    state => state.postalOperatorMailboxSelector.arrival.checkedMailboxes;
export const getExpandedArrivalPostalOperators =
    state => state.postalOperatorMailboxSelector.arrival.expandedPostalOperators;
export const getArrivalMailboxSelections =
    state => state.postalOperatorMailboxSelector.arrival.selections;
export const getArrivalPostalOperatorMailboxIsLoading =
    state => state.postalOperatorMailboxSelector.arrival.isLoading;

export const getDirections = state =>
  state.postalOperatorMailboxSelector.directions;
export const getIsDirectionsSwitched = state =>
  state.postalOperatorMailboxSelector.directions.switched;
